<template>
  <vs-tooltip text="Export XLSX" position="top">
    <vs-button
      radius
      class="mr-2"
      color="#333f50"
      type="flat"
      @click="exportXLSX"
      icon="cloud_download"
    ></vs-button
  ></vs-tooltip>
</template>

<script>
import moment from "moment";
import XLSX from "xlsx"; // import xlsx
import html2pdf from "html2pdf.js";
import jsPDF from "jspdf";
import "jspdf-autotable";
export default {
  props: {
    dataList: Array,
    headerName: String,
  },
  data: () => ({
    headerName: "",
    i: "",
    dataList: [],
    d: "",
    network: "",
    role: "",
    a: [],
    dataExport: [],
    dataActive: "",
  }),
  methods: {
    // exportPDF 
    exportXLSX() {
      //   console.log(this.headerName);
      //   switch (this.headerName) {
      //     case "ajinomotochart":
            this.dataList.forEach((element) => {
              this.dataExport.push({
                time: element.time,
                volume: element.volume,
              });
            });
      //       break;
      //     default:
      //       console.log("Try looking up for a hint.");
      //   }
      const dataWS = XLSX.utils.json_to_sheet(this.dataExport);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, dataWS);
      XLSX.writeFile(wb, this.headerName + ".xlsx");
      this.dataExport = [];
      this.dataActive = "";
    },
  },
};
</script>

<style>
</style>